var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10524_70774)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000244141 4.00073C0.000244141 2.89616 0.895675 2.00073 2.00024 2.00073H14.0002C15.1048 2.00073 16.0002 2.89616 16.0002 4.00073V11.3341C16.0002 12.4386 15.1048 13.3341 14.0002 13.3341H2.00024C0.895674 13.3341 0.000244141 12.4386 0.000244141 11.3341V4.00073ZM2.00024 3.33407C1.63205 3.33407 1.33358 3.63254 1.33358 4.00073V11.3341C1.33358 11.7023 1.63205 12.0007 2.00024 12.0007H14.0002C14.3684 12.0007 14.6669 11.7023 14.6669 11.3341V4.00073C14.6669 3.63254 14.3684 3.33407 14.0002 3.33407H2.00024Z",
    fill: "#4D4D54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3336 6.00021H0.666911V4.66688H15.3336V6.00021Z",
    fill: "#4D4D54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00024 8.00021H2.66691V7.33354H8.00024V8.00021Z",
    fill: "#4D4D54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66691 10.0002H2.66691V9.33354H6.66691V10.0002Z",
    fill: "#4D4D54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 8.00073C12.6668 8.73711 12.0698 9.33407 11.3334 9.33407C10.5971 9.33407 10.0001 8.73711 10.0001 8.00073C10.0001 7.26435 10.5971 6.6674 11.3334 6.6674C12.0698 6.6674 12.6668 7.26435 12.6668 8.00073Z",
    fill: "#4D4D54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 11.3561C13.3333 11.3484 13.3333 11.3407 13.3333 11.333C13.3333 10.2285 12.4379 9.33302 11.3333 9.33302C10.2288 9.33302 9.33346 10.2283 9.33332 11.3328L13.3333 11.333L13.3332 11.3561Z",
    fill: "#4D4D54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3659 13.3328H11.3007C11.3116 13.3329 11.3224 13.333 11.3333 13.333C11.3442 13.333 11.3551 13.3329 11.3659 13.3328Z",
    fill: "#4D4D54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10524_70774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.1acf94de19becd197cb1e925190473fc.svg";
export { ForwardRef as ReactComponent };